import { AxiosResponse } from 'axios';
import { changePassword, changeTimeZone } from '@/api/user';
import { AppError } from '@/errors/appError';

export const userService = {
    async changePassword(params: Record<string, string>): Promise<AxiosResponse | void> {
        try {
            return await changePassword(params);
        } catch (e) {
            throw new AppError(`Unable to change password, request error`, { cause: e });
        }
    },

    async changeTimeZone(timeZoneCode: string) {
        try {
            return await changeTimeZone(timeZoneCode);
        } catch (e) {
            throw new AppError(`Unable to change timeZone, request error`, { cause: e });
        }
    },
};
